<template>
  <modal :show.sync="show" :on-close="onClose">
    <woot-modal-header
      :header-title="title"
      :header-content="message"
      :header-content-value="messageValue"
    />
    <div class="modal-footer delete-item">
      <woot-button
        variant="clear"
        data-testid="reject-button"
        class="action-button"
        @click="onClose"
      >
        {{ rejectText }}
      </woot-button>
      <woot-button
        color-scheme="alert"
        class="action-button"
        variant="smooth"
        data-testid="confirm-button"
        @click="onConfirm"
      >
        {{ confirmText }}
      </woot-button>
    </div>
    <div v-if="isLoading" class="spinner-cover delete-modal-loading">
      <spinner-hoory size="medium" color="#fff" />
    </div>
  </modal>
</template>

<script>
import Modal from '../../Modal';
import SpinnerHoory from 'shared/components/SpinnerHoory.vue';

export default {
  components: {
    Modal,
    SpinnerHoory,
  },
  props: {
    show: Boolean,
    onClose: { type: Function, default: () => {} },
    onConfirm: { type: Function, default: () => {} },
    title: { type: String, default: '' },
    message: { type: String, default: '' },
    messageValue: { type: String, default: '' },
    confirmText: { type: String, default: '' },
    rejectText: { type: String, default: '' },
    isLoading: { type: Boolean, default: false },
  },
};
</script>
<style lang="scss" scoped>
.action-button {
  max-width: var(--space-giga);
}
::v-deep .wrap-content {
  min-height: 7rem;
}
.delete-modal-loading {
  top: 0;
  padding-top: var(--space-jumbo);
}
</style>
